const es = {
  translation: {
    menuPrincipal: {
      home: "Home",
      sobreNos: "Sobre Sagres",
      servicos: "Servicios",
      contato: "Contáctanos",
    },
    banner: {
      conectar: "Conéctate",
    },
    secaoSobre: {
      titulo: "SOMOS SAGRES!",
      primeiroParagrafo:
        "Inspirados por la Escuela de Sagres, que tenía como propósito enseñar la navegación y abrir nuevas rutas para el comercio, en Sagres Global estamos enfocados en encontrar soluciones para las empresas brasileñas.",
      segundoParagrafo:
        "Utilizamos la tecnología a nuestro favor, reduciendo las barreras y los costos para quienes desean internacionalizarse de manera eficiente.",
      terceiroParagrafo:
        "A través de la búsqueda de proveedores en todo el mundo, ofrecemos el servicio adecuado para encontrar los mejores productos, siempre considerando las necesidades del cliente y el cumplimiento de las normativas de las autoridades competentes.",
      card: {
        primeiroCard: {
          titulo: "NUESTRA MISIÓN",
          descricao:
            "Desarrollar la conexión entre proveedores y compradores, superando las barreras del comercio internacional.",
        },
        segundoCard: {
          titulo: "NUESTRA VISIÓN",
          descricao:
            "Ser la referencia en generar resultados a través de la búsqueda de proveedores y la constante mejoría de productos y procesos",
        },
        terceiroCard: {
          titulo: "NUESTROS VALORES",
          descricao:
            "Transparencia en las negociaciones, siempre buscando lo mejor para nuestros clientes y asociados, uniendo la tecnología y la innovación para alcanzar resultados.",
        },
      },
    },
    secaoServico: {
      titulos: {
        primeiroTitulo: "NUESTRO SERVICIO: PROCUREMENT",
        subtitulo: "CÓMO TRABAJAMOS",
      },
      descricao:
        "Pensando en resolver sus problemas, conectamos proveedores y compradores de manera fácil y sin burocracia.",
      cardInformacao: {
        item1: "Análisis inicial",
        desc1:
          "Recibimos su solicitación, realizamos un diagnóstico detallado y definimos los parámetros de la búsqueda.",
        item2: "Investigación global",
        desc2:
          "Utilizamos nuestra base de datos, que reúne millones de empresas, para identificar proveedores potenciales.",
        item3: "Evaluación cualificada",
        desc3:
          "Contactamos, evaluamos y seleccionamos proveedores con mayor potencial de éxito.",
        item4: "Validación de muestras",
        desc4:
          "Gestionamos las muestras de los proveedores con mayor alineación al proyecto, hasta su aprobación definitiva.",
        item5: "Costos y operación",
        desc5:
          "Conectamos al cliente con la empresa de trading, cuando es necesario, para la preparación de la estimación de costos de importación y la alineación operativa.",
      },
    },
    secaoDiferencial: {
      titulo: "NUESTROS",
      subtitulo: "DIFERENCIALES",
      primeiroDiferencial: "AGILIDAD",
      descricaoPrimeiroDiferencial:
        "Base de datos robusta con información de millones de empresas en diferentes mercados, potenciando la eficiencia y rapidez en la entrega del servicio contratado.",
      segundoDiferencial: "EXPERTISE",
      descricaoSegundoDiferencial:
        "Equipo de especialistas altamente calificado en procurement internacional, listos para identificar los proveedores adecuados para su negocio.",
      terceiroDiferencial: "CREDIBILIDAD",
      descricaoTerceiroDiferencial:
        "Nuestros análisis utilizan fuentes globales de referencia internacional, empleando rigor y consistencia en todo el proceso de búsqueda.",
    },
    formulario: {
      inputNome: "Su Nombre",
      inputEmail: "Su Email",
      inputMensagem: "Su Mensaje...",
      titulo: "CONTÁCTANOS",
      enviar: "Envío",
    },
    swall: {
      titulo: "Gracias",
      texto: "Correo envío",
    },
    agradecimento: {
      tituloBotao: "Devolver",
    },
  },
};

export { es };
